import { Box, Flex, Heading, Text } from '@chakra-ui/react';

import { Glyph } from '~/components/glyph';

export type MentorQualityCardProps = {
  title: string;
  description: string;
  glyphName: string;
};

export function MentorQualityCard({ title, description, glyphName }: MentorQualityCardProps) {
  return (
    <Box display='flex' flex='1' flexDirection='column' gap={3}>
      <Flex alignItems='center' gap={4}>
        {glyphName && <Glyph height={42} name={glyphName} width={42} />}
        {title && (
          <Heading as='h3' size='marketing-lg'>
            {title}
          </Heading>
        )}
      </Flex>
      {description && <Text>{description}</Text>}
    </Box>
  );
}
